module.exports = __webpack_public_path__ + "static/media/male.ba73c826.gif";